import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { useComposerStore } from '../hooks/useComposerStore'
import type { EditorActions } from './editorSlice'
import { selectEditorForDraft } from './editorSlice'

export const useEditorForDraft = (
  draftId: string,
): BufferEditor | undefined => {
  return useComposerStore((state) => selectEditorForDraft(state, draftId))
}

export const useSetEditor = (): EditorActions['setEditor'] => {
  return useComposerStore((state) => state.setEditor)
}

export const useRemoveEditor = (): EditorActions['removeEditor'] => {
  return useComposerStore((state) => state.removeEditor)
}
